$(document).ready(function () {
	$('form[data-form-loader]').submit(function () {
		let $button = $(this).find('button[type=submit]');
		$button.attr('disabled', 'disabled').text($(this).data('btn-text'));
	});
});